"use strict";
$(document).ready(function() {
    var $form = $('#admin-auth-form');
    var $submitButton = $('#sing_in_two_steps_submit');

    var $input1 = $form.find("[name=code_1]");
    var $input2 = $form.find("[name=code_2]");
    var $input3 = $form.find("[name=code_3]");
    var $input4 = $form.find("[name=code_4]");
    var $input5 = $form.find("[name=code_5]");
    var $input6 = $form.find("[name=code_6]");

    $input1.focus();

    $input1.on("keyup", function(e) {
        inputControls(e, $(this), $input2, null, true)
    });

    $input2.on("keyup", function(e) {
        inputControls(e, $(this), $input3, $input1)
    });

    $input3.on("keyup", function(e) {
        inputControls(e, $(this), $input4, $input2)
    });

    $input4.on("keyup", function(e) {
        inputControls(e, $(this), $input5, $input3)
    });

    $input5.on("keyup", function(e) {
        inputControls(e, $(this), $input6, $input4)
    });

    $input6.on("keyup", function(e) {
        inputControls(e, $(this), null, $input5, false, true);
    });

    function inputControls(e, activeInput, nextInput, prevInput, first=false, last=false){
        if (last && e.key === "Enter"){
            return false;
        } else if (e.keyCode == 8 || e.keyCode == 46) {
            if(!first && prevInput) prevInput.focus();
        }else if(e.keyCode == 37){
            if(!first && prevInput) prevInput.focus();
        } else if(e.keyCode == 39 && activeInput.val().length === 1){
            if(!last && nextInput) nextInput.focus()
        } else{
            if (activeInput.val().length === 1) {
                if(!last && nextInput) nextInput.focus();
                activeInput.val(e.key);
            }
        }
    }
});
